import { ProtocolEncryption } from '../data';

export interface MailServerUpdateRequestModel {
  // the saved server being tested (OAuth2 test only)
  id?: number;
  defaultServer?: boolean;
  customServer: boolean;
  authType?: string;
  oauthProvider?: string;
  clientId?: string;
  clientSecret?: string;
  tenantId?: string;
  accessToken?: string;
  refreshToken?: string;
  tokenExpiry?: string;
  scopes?: string;
  smtpHost: string;
  smtpPort: number;
  smtpEncryption: ProtocolEncryption;
  smtpUsername: string;
  smtpPassword: string;

  smtpFrom: string;
  smtpFromName: string;

  imapHost: string;
  imapPort: number;
  imapEncryption: ProtocolEncryption;
  imapUsername: string;
  imapPassword: string;
}
